import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-orca-logo',
  templateUrl: './orca-logo-svg.component.html',
  styleUrls: ['./orca-logo-svg.component.scss'],
  standalone: true,
})
export class OrcaLogoComponent {
  @Input() divStyling: string;
  @Input() logoWidthRem: number;
  @Input() logoHeightRem: number;
  @Input() logoWidth: string;
  @Input() logoHeight: string;
  @Input() logoType: 'black' | 'regular' = 'regular';
}
